import { Link } from 'react-router-dom';
import './HomeBackButton.css';

interface Props {
  variant?: 'light' | 'dark';
}

export default function HomeBackButton({ variant = 'dark' }: Props) {
  return (
    <Link to="/" className={`ib22-back ib22-back--${variant}`} aria-label="В меню">
      <span className="ib22-back__arrow">←</span>
      <span className="ib22-back__label">в меню</span>
    </Link>
  );
}
